import { Card, type CardProps, Collapse, styled } from '@mui/material';

import { useSwimlaneState } from '../../context';
import type { TCardId } from '../../types';
import { useFirstDraggingCardId } from '../dnd';

export const CardDropIndicator = ({
  cardId,
  isOver,
  ...props
}: CardProps & { cardId: TCardId; isOver: boolean }) => {
  const draggingCardId = useFirstDraggingCardId();
  const { onCardDropIndicatorShown, onCardDropIndicatorHidden, getCardHeight } = useSwimlaneState();

  return (
    <Collapse
      orientation="vertical"
      in={isOver}
      timeout={250}
      onEntered={() => onCardDropIndicatorShown(cardId, draggingCardId ?? '')}
      onExited={() => onCardDropIndicatorHidden(cardId)}
      mountOnEnter
      unmountOnExit
    >
      <DropIndicator elevation={0} height={getCardHeight(draggingCardId ?? '')} {...props} />
    </Collapse>
  );
};

export const DropIndicator = styled(Card, {
  shouldForwardProp: (prop: string) => prop !== 'height',
})<{
  height: number;
}>`
  height: ${(props) => props.height}px;
  background-color: #f5f5f5;
  border: 0;
  box-shadow: none;
`;
